import { FormEvent, useRef } from 'react';
import { Button } from '@seller/ui/Button';
import { DialogShell } from '@seller/ui/DialogShell';
import { useForm } from 'react-hook-form';
export function DeletionConfirmDialog({ version, pending, replay, close, confirm }: { version: string; pending: boolean; replay: boolean; close: () => void; confirm: () => void }) {
  const form = useForm<{ version: string }>({ defaultValues: { version: '' } });
  const typedVersion = form.watch('version');
  const versionField = form.register('version');
  const submit = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    if (!pending && typedVersion === version) confirm();
  };
  const cancel = useRef<HTMLButtonElement>(null);
  return (
    <DialogShell className="admin-modal" aria-label="Удалить версию карты?" aria-describedby="deletion-warning" initialFocusRef={cancel} isOpen isPending={pending} onClose={close} onMouseDown={(event) => { if (event.target === event.currentTarget) event.preventDefault(); }}>
      <form className="admin-modal__panel map-generations__dialog" onSubmit={submit}>
        <h2>Удалить версию карты?</h2>
        <p id="deletion-warning">Файлы будут удалены без возможности отмены для всех запусков с этой версией. История запусков сохранится.</p>
        <p className="map-generations__identifier">{version}</p>
        {replay && <p>Повторяется только ранее подтверждённый запрос с тем же ключом. Новый запрос не создаётся.</p>}
        <label className="admin-field">Введите версию полностью
          <input {...versionField} autoComplete="off" spellCheck={false} disabled={pending} />
        </label>
        <div className="map-generations__controls">
          <Button className="workspace-secondary-button" type="button" ref={cancel} disabled={pending} onClick={close}>Отмена</Button>
          <Button className="admin-submit" type="submit" disabled={pending || typedVersion !== version}>{pending ? 'Подтверждение…' : 'Подтвердить удаление'}</Button>
        </div>
      </form>
    </DialogShell>
  );
}
